import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

const PhotoTimeVideo = ({
  video,
  photoType,
  onEnded,
  background,
  setDisplayPhotoTime,
}) => {
  return (
    <>
      <CloudfrontVideoFormat
        source={video}
        back='/unit1'
        background={background}
        close={setDisplayPhotoTime}
        ended={() => onEnded(photoType)}
      />
    </>
  );
};

export default PhotoTimeVideo;
